import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const CostEstimationLayer = ({ view }) => {
  useEffect(() => {
    if (!view || !view.map) return;

    let graphicsLayer;

    const loadLayer = async () => {
      const [Graphic, GraphicsLayer] = await loadModules([
        'esri/Graphic',
        'esri/layers/GraphicsLayer'
      ]);

      const costEstimationWfs = 'https://portal.boom-h2-pipelines.com/geoserver/postgis/ows';
      const params = new URLSearchParams({
        service: 'WFS',
        version: '2.0.0',
        request: 'GetFeature',
        typeName: 'postgis:redlines',
        outputFormat: 'application/json'
      });

      const response = await fetch(`${costEstimationWfs}?${params}`);
      const geojson = await response.json();

      graphicsLayer = new GraphicsLayer({ title: 'Cost Estimation' });
      view.map.add(graphicsLayer);

      geojson.features.forEach(feature => {
        const geometry = convertGeometry(feature.geometry);
        const graphic = new Graphic({
          geometry,
          attributes: {
            ...feature.properties,
            id: feature.id.replace('redlines.', '')
          },
          symbol: getSymbolForType(feature.geometry.type)
        });
        graphicsLayer.add(graphic);
      });
    };

    const convertGeometry = (geom) => {
      const spatialRef = { wkid: 3857 };
      switch (geom.type) {
        case 'LineString':
          return { type: 'polyline', paths: [geom.coordinates], spatialReference: spatialRef };
        case 'MultiLineString':
          return { type: 'polyline', paths: geom.coordinates, spatialReference: spatialRef };
        case 'Point':
          return { type: 'point', x: geom.coordinates[0], y: geom.coordinates[1], spatialReference: spatialRef };
        case 'Polygon':
          return { type: 'polygon', rings: geom.coordinates, spatialReference: spatialRef };
        default:
          return null;
      }
    };

    const getSymbolForType = (type) => {
      if (type === 'Point') {
        return {
          type: 'simple-marker',
          style: 'circle',
          color: 'blue',
          size: 6
        };
      } else if (type === 'Polygon') {
        return {
          type: 'simple-fill',
          color: [0, 0, 255, 0.2],
          outline: {
            color: 'blue',
            width: 1
          }
        };
      } else {
        return {
          type: 'simple-line',
          color: 'red',
          width: 2,
          style: 'dash'
        };
      }
    };

    loadLayer();

    return () => {
      if (view?.map && graphicsLayer) {
        view.map.remove(graphicsLayer);
        graphicsLayer.destroy();
      }
    };
  }, [view]);

  return null;
};

export default CostEstimationLayer;
